module.exports = __webpack_public_path__ + "static/media/instructivoa7.007d0ed0.png";